import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

type State = typeof initialState;

function handleSuccess(state: State): State {
  return {
    ...state,
    queue: updateNotification(
      {
        key: "addPlanzoneResourceToProject",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    queue: updateNotification(
      {
        key: "addPlanzoneResourceToProject",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  };
}

// Adding everyone shows the same notification as adding the picked resources.
const reduceAddPlanzoneResourcesToProjectNotificationState = createStateReducer(
  initialState,
  {
    [events.addPlanzoneResourcesToProjectSucceeded]: handleSuccess,
    [events.addPlanzoneResourcesToProjectFailed]: handleFailure,
    [events.addEveryoneToProjectSucceeded]: handleSuccess,
    [events.addEveryoneToProjectFailed]: handleFailure,
  },
);

export { reduceAddPlanzoneResourcesToProjectNotificationState };
